import React from 'react';

interface HeaderProps {
  userName?: string;
  currentCVR?: string;
  onHomeClick: () => void;
  onProfileClick: () => void;
  onLogoutClick: () => void;
}

const Header: React.FC<HeaderProps> = ({
  userName,
  currentCVR,
  onHomeClick,
  onProfileClick,
  onLogoutClick
}) => {
  return (
    <header className="app-header">
      {/* Left side - Home icon and title */}
      <div className="header-left">
        <button
          onClick={onHomeClick}
          className="header-icon-btn"
          title="Gå til dashboard"
        >
          <svg
            className="header-icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
            />
          </svg>
        </button>
        <div className="header-title-group">
          <h1 className="app-title" onClick={onHomeClick}>
            FieldVision
          </h1>
          <p className="app-subtitle">Drone-baseret markanalyse</p>
        </div>
      </div>

      {/* Center - User info (optional) */}
      {(userName || currentCVR) && (
        <div className="header-center">
          <span className="user-info">
            {userName && <span className="user-name">{userName}</span>}
            {currentCVR && (
              <span className="user-cvr">CVR: {currentCVR}</span>
            )}
          </span>
        </div>
      )}

      {/* Right side - Profile and Logout icons */}
      <div className="header-right">
        <button
          onClick={onProfileClick}
          className="header-icon-btn"
          title="Profil"
        >
          <svg
            className="header-icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
            />
          </svg>
        </button>
        <button
          onClick={onLogoutClick}
          className="header-icon-btn"
          title="Log ud"
        >
          <svg
            className="header-icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
            />
          </svg>
        </button>
      </div>

      <style>{`
        .app-header {
          background-color: #031926;
          color: white;
          padding: 12px 24px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          min-height: 60px;
        }

        .header-left {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .header-title-group {
          display: flex;
          align-items: baseline;
          gap: 12px;
        }

        .app-title {
          font-size: 24px;
          font-weight: 700;
          margin: 0;
          cursor: pointer;
          transition: opacity 0.2s;
        }

        .app-title:hover {
          opacity: 0.9;
        }

        .app-subtitle {
          font-size: 13px;
          opacity: 0.9;
          margin: 0;
          display: none;
        }

        @media (min-width: 768px) {
          .app-subtitle {
            display: block;
          }
        }

        .header-center {
          display: none;
        }

        @media (min-width: 1024px) {
          .header-center {
            display: flex;
            align-items: center;
          }
        }

        .user-info {
          display: flex;
          flex-direction: column;
          align-items: center;
          font-size: 13px;
          opacity: 0.95;
        }

        .user-name {
          font-weight: 500;
        }

        .user-cvr {
          font-size: 12px;
          opacity: 0.85;
        }

        .header-right {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .header-icon-btn {
          background: rgba(255, 255, 255, 0.15);
          border: none;
          border-radius: 8px;
          padding: 8px;
          cursor: pointer;
          transition: background-color 0.2s, transform 0.1s;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .header-icon-btn:hover {
          background: rgba(255, 255, 255, 0.25);
        }

        .header-icon-btn:active {
          transform: scale(0.95);
        }

        .header-icon {
          width: 24px;
          height: 24px;
          color: white;
        }
      `}</style>
    </header>
  );
};

export default Header;
